type CurrencyObject = {
    currency: string;
    [key: string]: any;
};

export function isCurrencyInArray(currency: string, arr: CurrencyObject[]): boolean {
    return arr.some(obj => obj.currency === currency);
}

